import { render, staticRenderFns } from "./highlight.vue?vue&type=template&id=1726a3bc&scoped=true"
import script from "./highlight.vue?vue&type=script&lang=js"
export * from "./highlight.vue?vue&type=script&lang=js"
import style0 from "./highlight.vue?vue&type=style&index=0&id=1726a3bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1726a3bc",
  null
  
)

export default component.exports